import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { TaskStatus } from "../../models/task-status.model";

export namespace TaskStatusActions {

  @logDispatcher
  export class GetTaskStatus {
    static readonly type = '[TaskStatus] GetTaskStatus';
    constructor() { }
  }

  @logDispatcher
  export class GetTaskStatusSuccess {
    static readonly type = '[TaskStatus] GetTaskStatusSuccess';
    constructor(public taskStatus: TaskStatus[]) { }
  }

  @logDispatcher
  export class GetTaskStatusFail {
    static readonly type = '[TaskStatus] GetTaskStatusFail';
    constructor(public error: any) { }
  }
}
